import React from 'react';
import { ISVGType } from './SVGType';

const MobileSVG = (props: ISVGType) => {
  const { width = 30, height = 30, color = "#D1D4D6" } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle cx="15" cy="15" r="15" fill="#EFEFEF" />
      <path
        d="M18.2852 7C18.4121 7.05429 18.549 7.09317 18.6645 7.16581C19.0346 7.39874 19.1799 7.7553 19.1803 8.17862C19.181 10.9614 19.1806 13.7441 19.1806 16.5269C19.1806 17.9572 19.1821 19.3878 19.1795 20.818C19.1788 21.1313 19.1161 21.424 18.8802 21.6607C18.6777 21.8635 18.4407 21.9941 18.1575 21.9948C16.0923 22.0003 14.0267 22.0033 11.9615 21.9941C11.5869 21.9923 11.212 21.7215 11.0844 21.3411C11.0304 21.1805 11.0062 21.0026 11.0059 20.8324C11.0015 16.6094 11.0037 12.3865 11 8.16358C11 7.80189 11.0884 7.48568 11.3731 7.25164C11.4728 7.16947 11.6012 7.12215 11.7171 7.05979C11.7571 7.03852 11.7986 7.01981 11.8393 7C13.9878 7 16.1367 7 18.2852 7ZM15.9404 21.1717C15.9489 21.164 15.9573 21.1563 15.9658 21.1486V20.5774H14.1888V21.1486L14.2134 21.1717C14.7893 21.1717 15.3649 21.1717 15.9408 21.1717H15.9404ZM11.5943 19.7256H18.5523V9.2703H11.5943V19.7256ZM15.0799 7.84957C14.895 7.84957 14.7662 7.96659 14.7695 8.1302C14.7728 8.29197 14.8975 8.40715 15.0678 8.40642C15.2438 8.40569 15.3726 8.29087 15.377 8.13166C15.3814 7.96219 15.2625 7.84957 15.0799 7.84957Z"
        fill={color}
      />
    </svg>
  );
};

export default MobileSVG;
